import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6a2896a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OListaDeProfissionais",
  "data-testid": "OListaDeProfissionais"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "OListaDeProfissionais__TotalDeProfissionais",
  "data-testid": "OListaDeProfissionais__TotalDeProfissionais"
}
const _hoisted_4 = { class: "OListaDeProfissionais__Lista" }

import { computed } from "vue"
  import MItemDaListaDeProfissionais from "../MItemDaListaDeProfissionais/MItemDaListaDeProfissionais.vue"
  import { EntidadeGenerica } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  interface Props {
    profissionais: EntidadeGenerica[]
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OListaDeProfissionais',
  props: {
    profissionais: null
  },
  setup(__props: any) {

const props = __props as {
    profissionais: EntidadeGenerica[]
  }

  

  const { t } = useI18n()

  const totalDeProfissionais = computed(() => {
    return props.profissionais.length
  })

  const naoPossuiProfissionais = computed(() => {
    return totalDeProfissionais.value === 0
  })

  const possuiApenasUmProfissional = computed(() => {
    return totalDeProfissionais.value === 1
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(naoPossuiProfissionais))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('nenhum')), 1),
          _createTextVNode(" " + _toDisplayString(_unref(t)('profissionalAlocado')), 1)
        ]))
      : (_unref(possuiApenasUmProfissional))
        ? (_openBlock(), _createBlock(MItemDaListaDeProfissionais, {
            key: 1,
            "avatar-grande": true,
            "data-testid": "OListaDeProfissionais__ItemDaLista",
            profissional: props.profissionais[0]
          }, null, 8, ["profissional"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(_unref(totalDeProfissionais)), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('profissionaisAlocados')), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.profissionais, (profissional) => {
                return (_openBlock(), _createBlock(MItemDaListaDeProfissionais, {
                  key: profissional.id,
                  "data-testid": "OListaDeProfissionais__ItemDaLista",
                  profissional: profissional
                }, null, 8, ["profissional"]))
              }), 128))
            ])
          ], 64))
  ]))
}
}

})